import React from 'react'
import { filesize } from 'filesize'

export default class SizeWidget extends React.Component {

  state = {
    value: 0,
  }

  componentDidMount() {
    this.setState({
      value: this.props.size,
    })
  }

  onMouseUp(event) {
    this.props.setSize(this.props.id, event.target.value, (result) => {})
  }

  onChange(event) {
    this.setState({
      value: event.target.value,
    })
  }

  render() {
    return (
      <div>
        <label ref={'label_' + this.props.id} htmlFor={'range_' + this.props.id}>{'Taille: ' + filesize(this.state.value)}</label>
        <input id={'range_' + this.props.id} type="range" min="0" max="10737418240" step="104857600" defaultValue={this.props.size} onMouseUp={this.onMouseUp.bind(this)} onChange={this.onChange.bind(this)}/>
      </div>
    )
  }
}
